module.exports = "<main-header></main-header>\n\n<!--     reciepe details card      -->\n<app-recipe-details [recipe]=\"recipe\"></app-recipe-details>"